import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { VisibilityRounded } from '@mui/icons-material';
import DataGrid from 'components/DataGrid';
import RangePicker from 'components/RangePicker';
import TextField from 'components/TextField';
import { getAll } from './controller';
import dayjs from 'dayjs';

function LogIaList(){
  const navigate = useNavigate();
  
  const [ dateRange, setDateRange ] = useState({
    startDate: dayjs().format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD')
  });

  return(
    <DataGrid
      getData={(params) => getAll({...params, dateRange})}
      extra={
        <RangePicker
          sx={{ minWidth: '300px' }}
          value={dateRange}
          onChange={(value) => {
            setDateRange(value)
          }}
        />
      }
      columns={[
        { headerName: 'Data', field: 'createdAt', width: 200, sortable: false, filter: <TextField disabled/>, valueGetter: (params) => dayjs(params.value).format('DD/MM/YYYY - HH:mm')},
        { headerName: 'Cliente', field: 'cliente', flex: 1, sortable: false, filter: <TextField disabled/>},
        { headerName: 'Usuário', field: 'usuario', flex: 1, sortable: false, filter: <TextField disabled/>},
        { headerName: '', field: 'acao', width: 0, sortable: false, filter: <TextField disabled/>, renderCell: (params) =>
          <IconButton
            onClick={() => navigate(`/log-ia/${params.row.GUID}`)}
          >
            <VisibilityRounded/>
          </IconButton>
        },
      ]}
      emptyMessage="Nenhum registro de IA encontrado"
      getRowId={(row) => row.id}
    />
  );
};
export default LogIaList;